import { determineLayoutContext } from '@ott/layout-context';
import createKm from '@ott/utility-create-km';
import Cookie from 'js-cookie';

const getLayout = (): 'mobile' | 'desktop' => {
  const { isMobileLayout } = determineLayoutContext();

  return isMobileLayout ? 'mobile' : 'desktop';
};

const track = createKm('ActivitiesLike', {
  referrer: () => Cookie.get('referrer'),
  referrer_mrk: () => Cookie.get('referrer_mrk'),
  abst: () => Cookie.get('abst'),
  layout: getLayout,
});

export type TrackData = {
  localityId: number;
  page: string;
};

const onFirstLikeModalShow = (trackData: TrackData) =>
  track('ACT_FIRST_LIKE_MODAL_SHOW', trackData);
const onFirstLikeModalClose = (trackData: TrackData) =>
  track('ACT_FIRST_LIKE_MODAL_CLOSE', trackData);
const onFirstLikeModalAuthClick = (trackData: TrackData) =>
  track('ACT_FIRST_LIKE_MODAL_AUTH_CLICK', trackData);

export default {
  onFirstLikeModalShow,
  onFirstLikeModalClose,
  onFirstLikeModalAuthClick,
};
